var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrowave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 29.07",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "microwave"
  }, "Microwave Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "microwave"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72,14a.62.62,0,0,1-.44-.18.64.64,0,0,1,0-.89l5.77-5.76a.61.61,0,0,1,.88,0,.63.63,0,0,1,0,.88L8.17,13.82A.66.66,0,0,1,7.72,14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38,10.61a.62.62,0,0,1-.44-.18.64.64,0,0,1,0-.89L9.32,7.17a.61.61,0,0,1,.88,0,.63.63,0,0,1,0,.88L7.83,10.43A.66.66,0,0,1,7.38,10.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.23,29H2.77A2.75,2.75,0,0,1,0,26.29V2.83A2.75,2.75,0,0,1,2.77.08H45.23A2.75,2.75,0,0,1,48,2.83V26.29A2.75,2.75,0,0,1,45.23,29ZM2.77,1.58A1.25,1.25,0,0,0,1.52,2.83V26.29a1.25,1.25,0,0,0,1.25,1.25H45.23a1.25,1.25,0,0,0,1.25-1.25V2.83a1.25,1.25,0,0,0-1.25-1.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.48,24.89H5.67a1.5,1.5,0,0,1-1.5-1.5v-18a1.5,1.5,0,0,1,1.5-1.5H31.48A1.5,1.5,0,0,1,33,5.39v18A1.5,1.5,0,0,1,31.48,24.89ZM5.67,4.89a.5.5,0,0,0-.5.5v18a.5.5,0,0,0,.5.5H31.48a.5.5,0,0,0,.5-.5v-18a.5.5,0,0,0-.5-.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.38,9.38H36.24a1,1,0,0,1-1-1V5a1,1,0,0,1,1-1h7.14a1,1,0,0,1,1,1V8.38A1,1,0,0,1,43.38,9.38Zm0-1v0ZM36.24,5V8.38h7.14V5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.38,25H36.24a1,1,0,0,1-1-1V20.57a1,1,0,0,1,1-1h7.14a1,1,0,0,1,1,1V24A1,1,0,0,1,43.38,25Zm0-1v0Zm-7.14-3.41V24h7.14V20.57Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8,11.93H36.88a.5.5,0,0,1,0-1H38.8a.5.5,0,0,1,0,1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73,11.93H40.82a.5.5,0,0,1,0-1h1.91a.5.5,0,0,1,0,1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8,15H36.88a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H38.8a.5.5,0,0,1,.5.5A.5.5,0,0,1,38.8,15Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73,15H40.82a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1.91a.5.5,0,0,1,.5.5A.5.5,0,0,1,42.73,15Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8,18H36.88a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5H38.8a.5.5,0,0,1,.5.5A.5.5,0,0,1,38.8,18Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73,18H40.82a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1.91a.5.5,0,0,1,.5.5A.5.5,0,0,1,42.73,18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrowave);
export default __webpack_public_path__ + "static/media/microwave.6244f182097a2bf08a150eff795e48bb.svg";
export { ForwardRef as ReactComponent };